export default __webpack_public_path__ + "static/media/zukunf_lauft_m1.888a2450.png";